var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReSmsLinkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9064 15.8556L15.8561 10.9058C16.1978 10.5641 16.7519 10.5641 17.0936 10.9058C17.4353 11.2475 17.4353 11.8016 17.0936 12.1433L12.1438 17.093C11.8021 17.4347 11.2481 17.4347 10.9064 17.093C10.5647 16.7513 10.5647 16.1973 10.9064 15.8556Z",
    fill: "#6B7DE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2141 15.3254L21.1589 13.3806C22.9648 11.5746 22.9649 8.64662 21.1589 6.8406C19.3528 5.03475 16.4249 5.03475 14.6188 6.8406L12.6741 8.78537C12.3323 9.12694 11.7783 9.12703 11.4366 8.78537C11.095 8.44371 11.0951 7.88966 11.4366 7.54794L13.3814 5.60316C15.8708 3.1139 19.9069 3.1139 22.3963 5.60316C24.8858 8.0926 24.8856 12.1286 22.3963 14.6181L20.4515 16.5629C20.1098 16.9044 19.5558 16.9045 19.2141 16.5629C18.8728 16.2212 18.8727 15.667 19.2141 15.3254Z",
    fill: "#6B7DE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78583 12.6746L6.84106 14.6194C5.03515 16.4254 5.03504 19.3534 6.84106 21.1594C8.6471 22.9652 11.5751 22.9652 13.3811 21.1594L15.3259 19.2146C15.6676 18.8731 16.2217 18.873 16.5633 19.2146C16.905 19.5563 16.9049 20.1103 16.5633 20.4521L14.6185 22.3968C12.1291 24.8861 8.09308 24.8861 5.60362 22.3968C3.11418 19.9074 3.1143 15.8714 5.60362 13.3819L7.5484 11.4371C7.89012 11.0956 8.44417 11.0955 8.78583 11.4371C9.12715 11.7788 9.12728 12.333 8.78583 12.6746Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReSmsLinkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_SMS_link_icon.ccc2dd851058e648f9882e941d2ebc42.svg";